/**
 * Signup Cancel Page
 * 
 * Handles the redirect from Stripe Checkout when user cancels payment.
 * Redirects them back to pricing to try again.
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { useSafeMode } from '../contexts/SafeModeContext';

const SignupCancelPage = () => {
  const navigate = useNavigate();
  const { safeMode } = useSafeMode();
  
  return (
    <div className={`min-h-screen flex items-center justify-center ${
      safeMode ? 'bg-gray-50' : 'bg-slate-950'
    }`}>
      <Card className={`p-8 max-w-md text-center ${
        safeMode ? 'bg-white' : 'bg-slate-900 border-gray-800'
      }`}>
        <XCircle className={`w-12 h-12 mx-auto mb-4 ${
          safeMode ? 'text-orange-600' : 'text-orange-500'
        }`} />
        <h1 className={`text-xl font-semibold mb-2 ${
          safeMode ? 'text-gray-900' : 'text-white'
        }`}>
          Checkout Cancelled
        </h1>
        <p className={`mb-6 ${safeMode ? 'text-gray-600' : 'text-gray-400'}`}>
          No worries! Your payment was not processed. You can try again whenever you're ready.
        </p>
        <div className="space-y-3">
          <Button
            onClick={() => navigate('/pricing')}
            className={`w-full ${
              safeMode 
                ? 'bg-blue-600 hover:bg-blue-700' 
                : 'bg-red-600 hover:bg-red-700'
            }`}
          >
            Back to Pricing
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/')}
            className="w-full"
          >
            Go to Homepage
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default SignupCancelPage;
